import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { useApp } from "../AppContext";
import { TRUST, UI } from "../content";

export default function FloatingContact() {
  const { lang } = useApp();
  const wa = `https://wa.me/${TRUST.whatsapp}?text=${encodeURIComponent(UI.whatsapp_prefill[lang])}`;
  const tel = `tel:${TRUST.phone_after.replace(/\s+/g, "")}`;
  return (
    <div className="fixed bottom-5 right-5 z-[55] flex flex-col gap-3">
      <motion.a
        href={tel}
        data-testid="call-fab"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.1, type: "spring", stiffness: 200, damping: 18 }}
        whileHover={{ scale: 1.06 }}
        className="flex items-center gap-2 rounded-full bg-deepred-700 text-white pl-3 pr-4 py-3 shadow-[0_10px_30px_rgba(155,41,21,0.4)]"
        aria-label={UI.call_help[lang]}
      >
        <Phone className="w-6 h-6 shrink-0" />
        <span className="hidden sm:inline text-sm font-semibold whitespace-nowrap">{UI.call_help[lang]}</span>
      </motion.a>
      <motion.a
        href={wa}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-fab"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.25, type: "spring", stiffness: 200, damping: 18 }}
        whileHover={{ scale: 1.06 }}
        className="flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-3 pr-4 py-3 shadow-[0_10px_30px_rgba(37,211,102,0.4)]"
        aria-label={UI.whatsapp_help[lang]}
      >
        <svg viewBox="0 0 32 32" className="w-6 h-6 fill-white shrink-0">
          <path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.1 1.6 5.9L4 29l8.3-1.6c1.7.9 3.6 1.4 5.7 1.4 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-4.9 1 1-4.8-.2-.4c-1-1.6-1.5-3.4-1.5-5.3 0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10.1-10 10.1zm5.5-7.4c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5s-.7-1.7-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z"/>
        </svg>
        <span className="hidden sm:inline text-sm font-semibold whitespace-nowrap">{UI.whatsapp_help[lang]}</span>
      </motion.a>
    </div>
  );
}
